module.exports = ".espacio-personalizado {\r\n    padding-top: 3px !important;\r\n    padding-bottom: 3px !important;\r\n}"